import { render, staticRenderFns } from "./InputCopy.vue?vue&type=template&id=a3931ab4&"
import script from "./InputCopy.vue?vue&type=script&lang=js&"
export * from "./InputCopy.vue?vue&type=script&lang=js&"
import style0 from "./InputCopy.vue?vue&type=style&index=0&id=a3931ab4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports